import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addOffice } from "../../../store/actions"
import { useEffect } from "react"

const AddOffice = props => {
  const dispatch = useDispatch()
  document.title = "Add office"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      office_name: "",
    },
    validationSchema: Yup.object({
      office_name: Yup.string().required("Please Enter Office name"),
    }),
    onSubmit: values => {
      dispatch(addOffice(values, props.history))
    },
  })

  const office = useSelector(state => state.Office)
  const { error } = useSelector(state => ({
    error: state.Office.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Office" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="formOffice"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="office">
                            Office Name
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="office_name"
                            className={
                              validation.touched.office_name &&
                              validation.errors.office_name
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="office"
                            placeholder="Enter Office"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.office_name || ""}
                          />
                          {validation.touched.office_name &&
                          validation.errors.office_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.office_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {office && office.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddOffice
